import EachTicketPdf from "./EachTicketPdf";
// import { Colors } from "../../config";
// import styled, { css } from "styled-components";

const FlightTicketDownload = ({
  flightTicket,
  employeeTicketCount,
  guestTicketCount,
  type,
}) => {
  return (
    <>
      {flightTicket.map((eachTicket, idx) => {
        return (
          <div key={idx}>
            {/* {eachTicket.passengerType === "employee" && ( */}
            <EachTicketPdf
              type={type}
              idx={idx}
              eachTicket={eachTicket}
              // onDownloadClick={(id) => console.log("Download ", id)}
            />
            {/* )} */}
          </div>
        );
      })}

      {/* {employeeTicketCount > 0 && (
        <>
          {guestTicketCount > 0 && <DownloadHeader>Employee</DownloadHeader>}
          {flightTicket.map((eachTicket, idx) => {
            return (
              <div key={idx}>
                {eachTicket.passengerType === "employee" && (
                  <EachTicketPdf
                    eachTicket={eachTicket}
                    onDownloadClick={(id) => console.log("Download ", id)}
                  />
                )}
              </div>
            );
          })}
        </>
      )}
      {guestTicketCount > 0 && (
        <>
          <DownloadHeader paddingTop>Guest</DownloadHeader>
          {flightTicket.map((eachTicket, idx) => {
            return (
              <div key={idx}>
                {eachTicket.passengerType === "guest" && (
                  <EachTicketPdf
                    eachTicket={eachTicket}
                    onDownloadClick={(id) => console.log("Download ", id)}
                  />
                )}
              </div>
            );
          })}
        </>
      )} */}
    </>
  );
};

export default FlightTicketDownload;

// const DownloadHeader = styled.div`
//   color: ${Colors.bombay};
//   font-size: 0.75rem;
//   font-weight: 500;
//   ${(props) =>
//     props.paddingTop &&
//     css`
//       padding-top: 1rem;
//     `}
// `;
